import { CicleInterrogation } from 'components/Icons/CicleInterrogation'
import { IoCloseSharp } from 'react-icons/io5'
import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import {
    Body,
    ButtonAction,
    dialogPanel,
    dialogTitle,
    RulesContainer,
    RulesList,
    RulesTitle
} from './styles'

interface GroupMoreInfoModalProps {
    isOpen: boolean
    handleCloseModal: () => void
}

const GroupMoreInfoModal: React.FC<GroupMoreInfoModalProps> = ({
    isOpen,
    handleCloseModal
}) => {
    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-GroupMoreInfo"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <Dialog.Title
                                        as="h3"
                                        className={dialogTitle}
                                    >
                                        <p className="text-[#F0B323] text-xl font-semibold mt-2 mb-8">
                                            Tratamento em grupo
                                        </p>
                                        <IoCloseSharp
                                            onClick={handleCloseModal}
                                            className="text-blueTheme h-8 w-8 p-1 cursor-pointer absolute top-4 right-4"
                                        />
                                    </Dialog.Title>
                                    <Body>
                                        <div className="text-base text-gray-700 mb-5 text-left w-full">
                                            <div>Algumas notificações podem ser tratadas de uma única vez.</div>
                                            <div>Essa funcionalidade está disponível apenas para as notificações com casos específicos:</div>
                                        </div>

                                        <RulesContainer>
                                            <RulesTitle>
                                                Regras para tratamento em grupo:
                                            </RulesTitle>
                                            <div className="text-sm text-darkGray mb-2">
                                                Você pode tratar notificações em grupo quando todas seguirem os mesmos critérios:
                                            </div>
                                            <RulesList>
                                                <li className='text-darkGray'>Mesmo setor;</li>
                                                <li className='text-darkGray'>Mesma unidade;</li>
                                                <li className='text-darkGray'>Mesmo tipo de incidente;</li>
                                                <li className='text-darkGray'>Mesmo grau de dano, sendo somente:</li>
                                                <ul className="mt-2 space-y-1 text-darkGray">
                                                    <li className='text-darkGray'>- Circunstância Notificável</li>
                                                    <li className='text-darkGray'>- Near Miss</li>
                                                    <li className='text-darkGray'>- Evento sem dano;</li>
                                                </ul>
                                                <li className='text-darkGray'>Sem risco de imagem;</li>
                                                <li className='text-darkGray'>Não classificadas como Never Events;</li>
                                                <li className='text-darkGray'>Não envolve paciente;</li>
                                                <li className='text-darkGray'>Cálculo da Matriz de risco igual ou menor que 10.</li>
                                            </RulesList>
                                            <div className="text-sm text-gray-700 mt-6 text-left w-full">
                                                O tratamento pode incluir 2 até 50 notificações, mais recentes, por vez.
                                            </div>
                                        </RulesContainer>

                                        <div className="w-full flex justify-center mt-4">
                                            <ButtonAction
                                                onClick={handleCloseModal}
                                                className="bg-blueTheme text-white text-sm"
                                            >
                                                Ok
                                            </ButtonAction>
                                        </div>
                                    </Body>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export { GroupMoreInfoModal } 